export default "__VITE_ASSET__Du6FTJEu__"